
import { defineComponent, computed } from 'vue';
import marked from 'marked';
import DOMPurify from 'dompurify';

export default defineComponent({
  name: 'MarkdownDisplay',
  props: {
    markdown: {
      type: String,
      required: true,
      default: ''
    }
  },
  setup({ markdown }) {
    const html = computed(() => DOMPurify.sanitize(marked(markdown)));

    return {
      html
    };
  }
});
